import axios from 'axios';
import { normalizeEnumOption } from './enumOption';

const normalizeEnumGroups = (res) => {
  const sourceItems = Array.isArray(res) ? res : (Array.isArray(res && res.items) ? res.items : []);
  return sourceItems.map((list) => (Array.isArray(list) ? list : []).map(normalizeEnumOption));
};

// 查看银行回单
export const queryBankReceipt = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/financePublicBO.ajax?cmd=queryBankReceipt',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 银行流水
export const queryBankPayOutFlow = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/financePublicBO.ajax?cmd=queryBankPayOutFlow',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 公司平台支付列表
export const companyPayList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/manualPaymentBO.ajax?cmd=queryPayoutIntfs',
    method: 'post',
    data,
  }).then(async (res) => {
    const totalRes = await companyPayTotal(data);
    res = {
      ...res,
      ...totalRes,
    };
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 检测验证码
export const checkSmsCode = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/payByCashBO.ajax?cmd=checkSmsCode',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 查询是否可以直接输入密码，还是输入密码错误次数太多需要获取短信验证码
export const doQueryPassType = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/payByCashBO.ajax?cmd=doQueryPassType',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车队的支付密码
export const doWithdrawal = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/payByCashBO.ajax?cmd=doWithdrawal',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 公司支付-列表-付款-确定（系统自动转账/线下付款）
export const doQueryCheckPasswordErr = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/payByCashBO.ajax?cmd=doQueryCheckPasswordErr',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 公司支付-列表-付款-确定（系统自动转账）
export const balanceJudgment = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/financePublicBO.ajax?cmd=balanceJudgment',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 公司平台支付总览
export const companyPayTotal = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/manualPaymentBO.ajax?cmd=queryPayoutIntfsSum',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 公司平台支付审核
export const companyPayApprove = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/payByCashBO.ajax?cmd=sure',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 公司平台支付停止自动
export const companyPayStopAuto = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/manualPaymentBO.ajax?cmd=stopAutomatic',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 公司平台支付撤回
export const companyPayBack = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/payByCashBO.ajax?cmd=withdraw',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 账号列表
export const bankcardAccountList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/payByCashBO.ajax?cmd=queryBankBalanceInfoListNew',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 账号付款
export const bankcardAccountPay = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/payByCashBO.ajax?cmd=keySure',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 查快速付款账号
export const queryQuickAccount = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/payByCashBO.ajax?cmd=doQueryPayOutInfo',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 司机工资列表 --表头字段查询
export const driverSalaryListName = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmSalaryInfoNewBO.ajax?cmd=getCmsalaryTemplate',
    method: 'post',
    data,
  }).then(async (res) => {
    // 后端此接口直接返回裸数组：[{prop, label, ...}, ...]，不是 {items: ...}。
    // 兼容极少数被包装成 {items} 的响应，避免调用方 res.items.map 抛 undefined.map 错。
    if (Array.isArray(res)) {
      resolve({ items: res });
    } else if (res && Array.isArray(res.items)) {
      resolve(res);
    } else {
      resolve({ items: [], ...(res || {}) });
    }
  }).catch((err) => {
    reject(err);
  });
});

// 司机工资列表
export const driverSalaryList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmSalaryInfoNewBO.ajax?cmd=doQuery',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 司机工资补贴
export const driverSalarySubsidy = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmSalaryInfoNewBO.ajax?cmd=getDriverSubsidyInfo',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 司机工资修改
export const driverSalaryEdit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmSalaryInfoNewBO.ajax?cmd=modifySalaryInfo',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 司机工资发放工资单
export const setDriverSendBill = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmSalaryInfoNewBO.ajax?cmd=sendBillBySalary',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 司机工资结算
export const driverSalarySettlement = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmSalaryInfoNewBO.ajax?cmd=checkedSalaryBill',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 司机工资确认
export const driverSalarySure = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmSalaryInfoNewBO.ajax?cmd=salaryAffirm',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 司机工资上传附件
export const driverSalaryUploadFile = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmSalaryInfoNewBO.ajax?cmd=updateFile',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 司机工资申诉列表
export const driverSalaryComplaintList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmSalaryInfoNewBO.ajax?cmd=doQuerySalaryComplain',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 司机工资申诉审核
export const checkSalaryComplain = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmSalaryInfoNewBO.ajax?cmd=checkSalaryComplain',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 司机工资详情列表
export const driverSalaryDetailList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmSalaryInfoNewBO.ajax?cmd=getSalaryOrders',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 司机工资详情修改
export const driverSalaryDetailEdit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmSalaryInfoNewBO.ajax?cmd=updateSalaryOrderInfo',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 司机工资详情修改-- 更新两个月前的工资数据
export const updateSalaryByUser = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmSalaryInfoNewBO.ajax?cmd=updateSalaryByUser',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 员工工资列表
export const workerSalaryList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmStaffInfoNewBO.ajax?cmd=doQuery',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 发送工资单
export const workerSendBill = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmStaffInfoNewBO.ajax?cmd=sendBillByStaff',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 更新工资模板
export const workerUpdateTmpl = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmStaffInfoNewBO.ajax?cmd=compStaffTemplate',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 员工工资修改
export const workerEdit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmStaffInfoNewBO.ajax?cmd=modifySalaryInfo',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 员工工资结算
export const workerSettlement = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmStaffInfoNewBO.ajax?cmd=checkedStaffBill',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 上传批量更改
export const importUpdate = async (url, data) => new Promise((resolve, reject) => {
  axios({
    url,
    method: 'post',
    headers: {
      isForm: true,
      'my-header': 'my-header-value',
      // 需要 url 添加 code 然后 加签
      urlAddCodeAndSign: true,
    },
    data,
    customError: true,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 获取工资单项
export const getWorkerBillTitle = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmStaffInfoNewBO.ajax?cmd=getMaxTemplateFiel',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 设置工资单项
export const setWorkerBillTitle = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmStaffInfoNewBO.ajax?cmd=doSaveCmSalaryTemplate',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 提前到期列表
export const advanceList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/advanceExpireBO.ajax?cmd=doQuery',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 设置提前到期
export const advanceListSetExpire = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/advanceExpireBO.ajax?cmd=doExpire',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 票据
export const billMethodList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/sysTenantDefBo.ajax?cmd=getBillMethod',
    method: 'post',
    data,
  }).then(async (res) => {
    const result = res.items.map((item) => ({
      label: item.platName,
      value: item.userId,
    }));
    resolve(result);
  }).catch((err) => {
    reject(err);
  });
});
// 票据信息详情
export const invoiceDetail = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/billInfoBO.ajax?cmd=getBillInfoByAccountSeq',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 票据配置详情
export const invoiceSetInfo = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/billInfoBO.ajax?cmd=getBillSetting',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 票据修改
export const invoiceEdit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/billInfoBO.ajax?cmd=update',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 费率
export const rateList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/rateBO.ajax?cmd=getRateById',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 车队详情
export const fleetDetail = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/sys/tenant/sysTenantDefBo.ajax?cmd=getSysTenantDefById',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 修改车队
export const fleetEdit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/sysTenantDefBo.ajax?cmd=doSaveOrUpdate',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 公司银行卡列表
export const companyBankcardList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/sysTenantDefBo.ajax?cmd=queryTenantBankInfos',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 公司平台账户-查询对公、对私账户列表信息
export const companyPlatformAccountList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/payByCashBO.ajax?cmd=queryBankBalanceInfoListNew',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 公司平台账户- 获取充值账户信息
export const getRechargeAccount = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/accountBO.ajax?cmd=getPTAccountAndTailNumber',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 公司平台账户- 转移资金获取短信验证码
export const platformAccountGetSms = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/financePublicBO.ajax?cmd=getPingCode',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 公司平台账户- 资金互转
export const platformAccountMoneyTurn = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/financePublicBO.ajax?cmd=submit',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 公司平台账户- 提现
export const withdraw = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/accountBO.ajax?cmd=doWithdrawal',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 司机平台账户列表数据总览
export const driverAccountListTotal = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/accountBO.ajax?cmd=doAccountQuerySum',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 司机平台账户列表
export const driverAccountList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/accountBO.ajax?cmd=doAccountQuery',
    method: 'post',
    data,
  }).then(async (res) => {
    if (data.page === 1) {
      driverAccountList.totalRes = await driverAccountListTotal(data);
    }
    res.items = [
      {
        shortName: '合计',
        marginBalanceD: driverAccountList.totalRes.marginSum,
        oilBalanceD: driverAccountList.totalRes.oilSum,
        etcBalanceDD: driverAccountList.totalRes.etcSum,
        repairFundD: driverAccountList.totalRes.repairFundSum,
        pledgeOilcardFeeD: driverAccountList.totalRes.pledgeOilcardFeeSum,
        receivableOverdueBalanceD: driverAccountList.totalRes.receivableOverdueBalanceSum,
        payableOverdueBalanceD: driverAccountList.totalRes.payableOverdueBalanceSum,
      },
      ...res.items,
    ];
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 平账
export const balanceAccount = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/financePublicBO.ajax?cmd=saveForceZhangPing',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 查询司机账户余额
export const queryDriverAccountBalance = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/financePublicBO.ajax?cmd=queryOilAndEtcBalance',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 司机账户余额转移
export const driverBalanceTurn = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/financePublicBO.ajax?cmd=saveTurnCash',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 司机账单明细列表
export const driverBillList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/accountBO.ajax?cmd=doAccountQueryDetails',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 司机账单未到期列表
export const driverExpireList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/accountBO.ajax?cmd=getDealOrderInfo',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 切换账号状态
export const changeAccountStatus = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/manualPaymentBO.ajax?cmd=doAccountIn',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 清零油费
export const clearOilCost = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/financePublicBO.ajax?cmd=clearOil',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 充值油费
export const rechargeOilCost = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/financePublicBO.ajax?cmd=doSaveOilFee',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 公司其他账户
export const otherAccountList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/escrowAccountBO.ajax?cmd=getAccountBalance',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 公司其他账户 - 流水
export const otherAccountRecord = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/escrowAccountBO.ajax?cmd=getByPage',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 余额登记
export const setAccountBalance = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/escrowAccountBO.ajax?cmd=doSave',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 收款人列表
export const receipertList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/userReceiverInfoBO.ajax?cmd=queryUserReceiverInfo',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 收款人详情
export const receipertDetail = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/userReceiverInfoBO.ajax?cmd=getUserReceiverInfo',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 收款人 - 修改
export const receipertEdit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/userReceiverInfoBO.ajax?cmd=create',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 收款人 - 移除
export const receipertDel = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/userReceiverInfoBO.ajax?cmd=remove',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 客户应收 - 应收订单
export const customerOrderList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/receviceManageBO.ajax?cmd=queryReceviceManageOrder',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 客户应收 - 应收订单 - 对账数据
export const getOrderDiffList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/receviceManageBO.ajax?cmd=getOrderDiffList',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 客户应收 - 应收订单 - 对账数据保存
export const saveOrderDiff = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/receviceManageBO.ajax?cmd=saveOrderDiff',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 客户应收 - 应收订单汇总
export const customerOrderTotal = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/receviceManageBO.ajax?cmd=findOrderReceivableFeeSum',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 客户应收 - 创建账单
export const customerOrderCreateBill = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/orderBillInfoBO.ajax?cmd=createOrderBill',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 客户应收 - 修改对账名称
export const customerOrderChangeCheckName = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/orderBillInfoBO.ajax?cmd=batchUpdateCheckName',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 客户应收 - 账单列表
export const customerBillList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/orderBillInfoBO.ajax?cmd=doQuery',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 客户应收 - 核销列表
export const customerBillWriteOffList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/orderBillInfoBO.ajax?cmd=queryChecksByBillNumber',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 客户应收 - 核销修改
export const customerBillWriteOffEdit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/orderBillInfoBO.ajax?cmd=saveChecks',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 客户应收 - 发票列表
export const customerBillInvoiceList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/orderBillInfoBO.ajax?cmd=queryBillReceipt',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 客户应收 - 发票修改
export const customerBillInvoiceEdit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/orderBillInfoBO.ajax?cmd=saveOrderBillReceipt',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 客户应收 - 账单回退
export const customerBillBack = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/orderBillInfoBO.ajax?cmd=uodoBill',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 客户应收 - 添加订单
export const customerBillAddOrder = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/orderBillInfoBO.ajax?cmd=billAddOrders',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 客户应收 - 删除订单
export const customerBillDelOrder = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/orderBillInfoBO.ajax?cmd=billReduceOrders',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 支付查询 - 结果列表
export const payResultList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/manualPaymentBO.ajax?cmd=queryPayOut',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 支付查询 - 结果列表
export const payBankFlowList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/financePublicBO.ajax?cmd=getBankFlowDetailsthrows',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 应收订单-列表-导入按钮
export const createOrderBillByExcel = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/orderBillInfoBO.ajax?cmd=createOrderBillByExcel',
    method: 'post',
    data,
    headers: {
      isForm: true,
      urlAddCodeAndSign: true,
    },
  }).then((res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 客户应收 - 其他收入
export const otherIncomeList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/incomeAndExpenditureBO.ajax?cmd=queryOtherIncomePage',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 客户应收 - 其他收入 - 交易用途查询
export const getOtherIncomeSysData = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/incomeAndExpenditureBO.ajax?cmd=getOtherIncomeSysData',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(normalizeEnumGroups(res));
  }).catch((err) => {
    reject(err);
  });
});

// 客户应收 - 其他收入 -新增
export const otherIncomeEdit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/incomeAndExpenditureBO.ajax?cmd=saveOtherIncome',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 客户应收 - 其他收入 -删除
export const doRemoveOtherIncome = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/incomeAndExpenditureBO.ajax?cmd=doRemoveOtherIncome',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 客户应收 - 其他收入 - 其他收入金额统计
export const otherIncomeTotal = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/incomeAndExpenditureBO.ajax?cmd=findOtherIncomeFeeSum',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 客户应收 - 其他收入 - 新增交易用途
export const addTransactionPurpose = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/staticDataBO.ajax?cmd=saveTransactionPurpose',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 客户应收 - 其他收入 - 设置初始余额
export const addBankBalance = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/pinganBO.ajax?cmd=addBankBalance',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 账户管理 - 收支明细
export const incomeDetailList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/incomeAndExpenditureBO.ajax?cmd=queryIncomeAndExpendPage',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 账户管理 - 收支明细 - 交易用途查询
export const getPaymentDetailsSysData = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/incomeAndExpenditureBO.ajax?cmd=getPaymentDetailsSysData',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(normalizeEnumGroups(res));
  }).catch((err) => {
    reject(err);
  });
});

// 账户管理 - 收支明细 - 收入支出汇总
export const incomeAndExpenseTotal = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/incomeAndExpenditureBO.ajax?cmd=findIncomeAndExpendFeeSum',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 账户管理 - 收支明细 - 实时余额汇总
export const accountBalanceTotal = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/incomeAndExpenditureBO.ajax?cmd=findAccountBalanceSum',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
